import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';

const AdminContainer = styled(Container)(({ theme }) => ({
  maxWidth: '1440px !important',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    paddingLeft: '0px',
    paddingRight: '0px'
  }
}));

export default AdminContainer;
